import type {
  ISendMfaCodeRequest,
  IVerifyMfaCodeRequest,
} from '../types/PhoneVerification';
import {
  OTP_TYPE_CHANGE_PHONE,
  type ISendOtpApiPayload,
  type ISetPhoneApiPayload,
  type IVerifyOtpApiPayload,
} from '../types/PhoneVerification.api';

const toSendOtpPayload = (input: ISendMfaCodeRequest): ISendOtpApiPayload => ({
  otpType: OTP_TYPE_CHANGE_PHONE,
  identifier: input.phone,
});

const toVerifyOtpPayload = (input: IVerifyMfaCodeRequest): IVerifyOtpApiPayload => ({
  otpType: OTP_TYPE_CHANGE_PHONE,
  identifier: input.phone,
  otpCode: input.otpCode,
});

const toSetPhonePayload = (
  input: IVerifyMfaCodeRequest,
  requestToken: string,
): ISetPhoneApiPayload => ({
  requestToken,
  newPhone: input.phone,
});

export const PhoneVerificationAdapters = {
  toSendOtpPayload,
  toVerifyOtpPayload,
  toSetPhonePayload,
};
